var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPvanlageDeactivated = function SvgPvanlageDeactivated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#D4D4D4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M2.657 26.638h7.553v7.481H2.657zM12.368 26.638h7.553v7.481h-7.553zM22.079 26.638h7.554v7.481h-7.554zM31.79 26.638h7.554v7.481H31.79zM2.657 36.259h7.553v7.481H2.657zM12.368 36.259h7.553v7.481h-7.553zM22.079 36.259h7.554v7.481h-7.554zM31.79 36.259h7.554v7.481H31.79zM2.657 45.881h7.553v7.48H2.657zM12.368 45.881h7.553v7.48h-7.553zM22.079 45.881h7.554v7.48h-7.554zM31.79 45.881h7.554v7.48H31.79z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#D4D4D4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M44.973 19.998c0-4.953-4.017-8.973-8.971-8.973-4.96 0-8.979 4.02-8.979 8.973 0 1.643.449 3.178 1.219 4.502H41.5v2.58a8.953 8.953 0 0 0 3.473-7.082z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#D4D4D4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M.5 24.5v31h41v-31H.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    fill: "none",
    stroke: "#D4D4D4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M23.415 19.998H16.5M44.896 28.9l4.892 4.891M48.584 20.003l6.916-.001M44.9 11.104l4.891-4.891M36.003 7.416 36.002.5M27.104 11.1l-4.891-4.891"
  })));
};
export default SvgPvanlageDeactivated;